module.exports = __webpack_public_path__ + "img/grose.0ef005e1.webp";